import { render, staticRenderFns } from "./vipLook.vue?vue&type=template&id=7d2ca088&scoped=true"
import script from "./vipLook.vue?vue&type=script&lang=js"
export * from "./vipLook.vue?vue&type=script&lang=js"
import style0 from "./vipLook.vue?vue&type=style&index=0&id=7d2ca088&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d2ca088",
  null
  
)

export default component.exports